import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  InputCheckboxListComponent,
} from '../../../../../../shared/components/input-checkbox-list/input-checkbox-list.component';
import {
  InputCheckboxListInterface,
  InputCheckboxListOption,
} from '../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-report-column-step',
  imports: [
    InputCheckboxListComponent,
  ],
  templateUrl: './column-step.html',
  styleUrl: './column-step.css',
})
export class ReportColumnStep {
  @Input({required: true}) formGroup!: FormGroup;

  @Input({required: true}) column: InputCheckboxListOption[] = [];

  public get selectConfig(): InputCheckboxListInterface {
    return {
      id: 'list',
      formGroup: this.formGroup,
      isTranslated: true,
      label: 'common.input.column-select.label',
      options: this.column,
    };
  }
}
